export default "__VITE_ASSET__9FoOJHuT__"